import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    error: 'Something went wrong',
    successCopy:
      'The card number has been copied! Make sure to use it on a website you trust.',
  },
  fr: {
    error: 'Une erreur est survenue',
    successCopy:
      'Le numéro de carte a bien été copié\u00A0! Veillez à l’utiliser sur un site de confiance.',
  },
});

export default locales;
